<template>
  <v-dialog
    v-model="visibility"
    max-width="500"
    persistent
  >
    <v-card>

      <div class="px-0">

        <v-card-title class="headline pl-4 py-2 pr-2">
          Utwórz nowy folder
          <v-spacer></v-spacer>
          <v-btn
            @click.native="visibility = false"
            icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>
        <div>
          <v-alert
            v-model="error"
            class="ma-0"
            dismissible
            type="error"
          >
            {{errorMsg}}
          </v-alert>
          <div class="pt-4">
            <div class="px-4">
              <div class="body-2 grey--text">
                Podaj nazwę folderu
              </div>
            </div>

            <div class="px-4">
              <v-text-field
                v-model.trim="directoryName"
                label="Nazwa folderu"
                :error-messages="errors.collect('name')"
                v-validate="'max:250|required'"
                data-vv-name="name"
                data-vv-as="nazwa folderu"
                required
              ></v-text-field>
            </div>
          </div>
          <v-card-actions class="px-4 py-4">
            <ServerErrors :errorsItems="serverErrors" />

            <v-spacer></v-spacer>

            <v-btn
              color="primary lighten-2"
              flat="flat"
              @click="setVisbility"
            >
              Anuluj
            </v-btn>

            <v-btn
              color="primary"
              :loading="busy"
              :disabled="busy"
              @click="storeNewDir"
            >
              Zapisz
            </v-btn>
          </v-card-actions>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getError } from '../../../helpers/helpers';
import ServerErrors from '../../common/Errors/ServerErrors.vue';

export default {
  name: 'create-folder-dialog',
  components: {
    ServerErrors,
  },
  data: () => ({
    busy: false,
    errorMsg: null,
    error: null,
    serverErrors: [],
    directoryName: null,
  }),
  computed: {
    ...mapGetters('files', [
      'dialogVisibility',
    ]),
    visibility: {
      get() {
        return this.dialogVisibility.type === 'createFolder';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
  },
  methods: {
    ...mapActions('files', [
      'setDialogVisbility',
      'storeDir',
    ]),
    setVisbility() {
      this.setDialogVisbility(false);
    },
    getServerErrors(errors) {
      const filedKeys = Object.keys(errors);
      filedKeys.forEach((fieldKey) => {
        const fieldErros = errors[fieldKey];
        if (!fieldErros[0] || fieldErros.length <= 0) return;
        fieldErros.forEach((err) => {
          const field = this.$validator.fields.find({
            name: fieldKey,
            scope: this.$options.scope,
          });
          if (field) {
            this.$validator.errors.add({
              id: field.id,
              field: fieldKey,
              msg: err,
              scope: this.$options.scope,
            });
            field.setFlags({
              invalid: true,
              valid: false,
              validated: true,
            });
          } else if (!this.serverErrors.includes(err)) {
            this.serverErrors.push(err);
          }
        });
      });
    },
    getError(errorData) {
      this.dialogBusy = false;
      this.busy = false;
      this.errorMsg = getError(errorData);
      this.error = true;
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.scrollTo(0, 0);
      }
      if (errorData.response.data && errorData.response.data.data) {
        this.getServerErrors(errorData.response.data.data);
      }
    },
    clearData() {
      this.$validator.reset();
      this.busy = false;
      this.errorMsg = null;
      this.error = null;
      this.serverErrors = [];
      this.directoryName = null;
    },
    storeNewDir() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.createNewDir();
        }
      });
    },
    async createNewDir() {
      this.busy = true;
      try {
        const dirData = {
          ...this.dialogVisibility.data,
          name: this.directoryName,
        };
        await this.storeDir(dirData);
        this.busy = false;
      } catch (e) {
        this.getError(e);
      }
    },
  },
  watch: {
    visibility(val, oldVal) {
      if (oldVal) {
        this.clearData();
      }
    },
  },
};
</script>
